import * as client from 'filestack-js';
import {UploadOptions} from 'filestack-js/build/main/lib/api/upload/types';
import ReactFileStack from './ReactFileStack';

export default ReactFileStack;
export { client };
export type { UploadOptions };
